import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import fr from '@/i18n/fr';
import en from '@/i18n/en';

const translations = { fr, en };

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('affea-lang') || 'fr');

  useEffect(() => {
    localStorage.setItem('affea-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.fr[key] || key;
  }, [lang]);

  const toggleLanguage = () => setLang(prev => prev === 'fr' ? 'en' : 'fr');

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
